angular.module('rjmNg.directives').directive "magentoLogin", [
  () ->
    restrict: "E"
    templateUrl: "directive.magentoLogin.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    scope: {}
    controller: [
      "$anchorScroll"
      "$routeParams"
      "$window"
      "notification"
      "Password"
      "Session"
      "Users"
      (
        $anchorScroll,
        $routeParams,
        $window,
        notification,
        Password,
        Session,
        Users
      ) ->

        MESSAGES =
          ERROR: "We ran into a problem resetting your password.  Please contact
            <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

          BLOCKED: "You have exceeded the number of allowed password reset attempts.
            Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

        PRETTY_SESSION_MESSAGES =
          "Session:Forbidden": "Please verify that your password is correct."

          "Session:Throttled": "There have been too many recent sign in attempts
            for the email address you entered. Please try signing in again in a
            couple of minutes."

        view = @

        view.loading

        view.userEmail = decodeURIComponent($routeParams.email)

        view.password = null

        view.hasResetPassword = false

        view.resetPassword = ->
          notification.clear "magento-login"
          view.loading = true
          Password.reset(view.userEmail, "dashboard")
            .then () ->
              view.loading = false
              view.hasResetPassword = true
            .catch (error) ->
              view.loading = false
              if error.status is 429
                notification.error("Password Reset Failed.", MESSAGES.BLOCKED, "magento-login", { dismissable: false, bindHtml: true })
              else
                notification.error("Password Reset Failed.", MESSAGES.ERROR, "magento-login", { dismissable: false, bindHtml: true })


        view.login = ->
          notification.clear "magento-login"
          view.loading = true
          Session.create(view.userEmail, view.password, false)
            .then (response) ->
              $window.location = response.redirect ? "/"
            .catch ({data}) ->
              errorMessage = PRETTY_SESSION_MESSAGES[data.error?.type] ? null
              if errorMessage?
                notification.error("Login Failed", errorMessage, "magento-login", { dismissable: false, bindHtml: true })
              view.loading = false

        $anchorScroll()
        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "magentoLogin", scope.view.loading
]
